// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__ixMZu","vLegacy":"SelectSecondary_vLegacy__QX99H","error":"SelectSecondary_error__3-IZM","disabled":"SelectSecondary_disabled__3Yjch"};